import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authRoutes/$')({
  beforeLoad: () => {
    throw redirect({
      to: '/',
    })
  },
  component: () => (
    <div className="text-center">
      <p>Redirecting to dashboard...</p>
    </div>
  ),
})
